import {GenderResponseBody} from '@dms/api/shared';

export const gendersResponseMock: GenderResponseBody[] = [
  {
    code: 'GENDER_MALE',
    name: 'Male',
  },
  {
    code: 'GENDER_FEMALE',
    name: 'Female',
  },
  {
    code: 'GENDER_OTHER',
    name: 'Other',
  },
];
